import * as React from "react";
import { Box, CircularProgress } from "@material-ui/core";
import "./Loader.scss";

interface LoaderProps {
  height?: number;
  loadingText?: string;
}

const Loader: React.FC<LoaderProps> = (props) => {
  const { height, loadingText } = props;

  return (
    <div
      className="loader"
      style={{
        height: height ? height.toLocaleString() + "rem" : "18.75rem",
        margin: "auto",
      }}
    >
      <Box
        component="div"
        className="loader-wrapper"
        style={{
          height: height ? height.toLocaleString() + "rem" : "18.75rem",
        }}
      >
        <CircularProgress style={loadingText ? { marginRight: ".625rem" } : undefined} />
        {loadingText}
      </Box>
    </div>
  );
};

export default Loader;
